import SuperParagraphComponent from '../content-types/superParagraph';

function SuperParagraph({ attrs }) {
    if (!attrs?.data) {
        return null;
    }

    return (
        <>
            <SuperParagraphComponent {...attrs.data} />
        </>
    );
}

export default SuperParagraph;
